'use strict';
const React = require('react');
const BaseComponent = require('../../../../shared/base');

class CustomCartComponent extends BaseComponent {
    constructor(props) {
        super(props);
    }
}

module.exports = CustomCartComponent;